import { FormattedEvent } from '@eventbrite/consumer-search.event-renderer';
import { EventCard } from '../EventCard/EventCard';
import styles from './EventCardsBucket.module.scss';

interface Props {
    label: string;
    affCode: string;
    events: FormattedEvent[];
    isAuthenticated: boolean;
    showSaveAction?: boolean;
    showShareAction?: boolean;
}

export const EventCardsBucket: React.FC<Props> = ({
    label,
    affCode,
    events,
    isAuthenticated,
    showSaveAction = false,
    showShareAction = false,
}) => {
    return (
        <div className={styles.feedEventsBucket}>
            {events.map((event) => (
                <EventCard
                    key={event.id}
                    event={event}
                    affCode={affCode}
                    bucketLabel={label}
                    hidePriceDescription={false}
                    isAuthenticated={isAuthenticated}
                    showSaveAction={showSaveAction}
                    showShareAction={showShareAction}
                />
            ))}
        </div>
    );
};
